import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { OnboardingFinishedConstants as ui } from '../../Config/UIConstants';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { colors } from '../../styles/colors';

interface IProps {
    store: ApplicationStore;
}
@inject('store')
@observer
export class OnboardingFinished extends React.Component<RouteComponentProps<any> & IProps> {
    private goToHomePage = () => {
        this.props.history.push(Routes.ALBUMS);
    }

    public componentDidMount(): void {
        if (this.props.location.state && this.props.location.state.shouldCreateAccount) {
            this.props.store.onboardingStore.postAllOnboardingData();
        }
    }

    public render() {
        let onClickFinish = this.goToHomePage;

        return (
            <FullScreenModalContainer {...this.props} justifyContent="space-between" alignItems="center">
                <p style={styles.headerText}>{ui.MAIN_HEADER}</p>

                <div style={styles.copyContainer}>
                    {ui.PARAGRAPHS.map((paragraph, i) => {
                        let style: React.CSSProperties | undefined;
                        if (i > 0) {
                            style = styles.successiveParagraph;
                        }
                        return <p key={i} style={style}>{paragraph}</p>;
                    })}
                </div>

                <div style={styles.bottomContainer}>
                    <CommonActionButton
                        buttonContent={ui.FINISH}
                        containerStyle={styles.buttonContainer}
                        fontStyle={styles.buttonText}
                        onClick={onClickFinish}
                    />
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    successiveParagraph: {
        marginTop: '0.8em',
    },
    containObject: {
        objectFit: 'contain',
    },
    invitedFinishedText: {
        marginBottom: 25,
        opacity: 1,
        textAlign: 'center',
        fontSize: 20,
        width: 600,
    },
    textIcon: (extraPadding?: number) => {
        return {
            height: 50 - (extraPadding ? 0 : 10),
            width: 50,
            objectFit: 'contain',
            marginRight: 20,
            paddingBottom: extraPadding,
        };
    },
    textWithIconContainer: {
        width: 485,
        display: 'flex',
        alignItems: 'center',
        height: 50,
        marginBottom: 25,
    } as React.CSSProperties,
    text: {
        fontSize: 18,
        paddingLeft: 15,
    },
    buttonText: {
        fontSize: 25,
        fontWeight: 200,
        letterSpacing: 1,
    } as React.CSSProperties,
    buttonContainer: {
        height: 68,
        width: 270,
    },
    bottomContainer: {
        height: 150,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    } as React.CSSProperties,
    copyContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: 25,
        width: '60%',
        textAlign: 'center',
    } as React.CSSProperties,
    headerText: {
        fontSize: 45,
        color: colors.DARK_TEXT,
        marginTop: 150,
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingFinished.tsx